import React, {useState, useEffect} from 'react';
import { generatedOfferDoc, richEditorDoc } from '../gestioneDatabase/Docs';
import VisDiv from '../frontend_components/VisDiv';
import { v4 as uuidv4 } from 'uuid';
import { keyId } from '../../lib/utils'; 
import {FiSave } from 'react-icons/fi'
import { GroupedPin } from './GroupedPin';
import { useStateContext } from '../../context/StateContext';
import TextField from '../TextField';
import { InsertProduct } from './InsertProduct';

const AddManualProduct = ({saveFn, commonStyle, data={}}) => {
   //#offerManualProduct
    const {offer} = useStateContext()

    const {offerField, emptyDocGeneratedData, register, labourProduct, priceList, allProducts, setIsAdding, siteRegisters} = data
    //console.log("empty doc generated data",emptyDocGeneratedData)
    const [newUnit, setNewUnit] = useState("1") 
    //useEffect(()=>{setNewUnit(unit ? unit : "1" )},[unit])
    
    const isSign = emptyDocGeneratedData?.isSign
    const filteredProducts = allProducts?.customerProducts
/*     ?.filter?.((x)=>{
        //console.log("cjwlcjweljc", {register, x})
        const filterByRegisterTemplate = x?.registers?.some?.((y)=>y?._ref == register?.template?._ref) 
        if(isSign) return x?.isSign && filterByRegisterTemplate
        return !x?.isSign && filterByRegisterTemplate
      }) */

    const [customerProducts, setCustomerProducts] = useState(filteredProducts)  
    const defaultManualDoc = generatedOfferDoc({
        //...dataArray[0],
        //_id: uuidv4(),
       // _key: keyId(),
        customerProduct:"PRODOTTO MANUALE",
        _id: uuidv4(),
        _key: keyId(),
        description: richEditorDoc(""),
        descriptionText:"",
        labourProduct,
        law: richEditorDoc(""),
        registerId: emptyDocGeneratedData?.registerId?.toString(),
        siteId: emptyDocGeneratedData?.siteId?.toString(),
        isSign: emptyDocGeneratedData?.isSign, 
        labourProduct: emptyDocGeneratedData?.labourProduct, 
        registerTemplateId: emptyDocGeneratedData?.registerTemplateId, 
        offerPropertyId: emptyDocGeneratedData?.offerProperty?._id, 
        offerPropertyLabel: emptyDocGeneratedData?.offerProperty?.label, 
        location: "", 
        quantity: "1",
        order:"-1",
        unit: "1",
        discount: emptyDocGeneratedData?.discount?.toString(),
        isManual: true,
        deviceFamilyId: emptyDocGeneratedData?.deviceFamilyId, 
        supplierPrice: "0",
        unitPrice: "0", 
      })
    const [manualDoc, setManualDoc] = useState(defaultManualDoc)
    const setProduct = (data) => {

        const {description, law, supplierPrice, unitPrice, pricelistCode, customerProduct, unit, customerProductId} = data
        const quantity = () => {
          if (newUnit) return Number(newUnit)
          if(unit)  {
            if(!Number(unit)) return 1
            return Number(unit)
          }
          return 1
        }
        const supplierPriceChecked =  supplierPrice ? supplierPrice : "0"   
        
        setManualDoc({
          ...manualDoc, 
          customerProductId,
          description, 
          law, 
          supplierPrice, 
          unitPrice, 
          pricelistCode, 
          customerProduct, 
          supplierPrice: supplierPrice, 
          unit: newUnit ? newUnit : "1" , 
          supplierPrice: supplierPriceChecked,
          quantity: quantity()
        })

    }

    const setContent = (data, objKey) => {
        //console.log("SET CONTENT:", data, objKey)
        const updatedDoc = (product, newValue, key) => {
          const docKey = () => {
            //if(key=="quantity") return "manualQuantity"
            return key
          }
          const doc = {
            ...product,
            [docKey()]:newValue[key]
          }
          return doc
  
        }
        setManualDoc(updatedDoc(manualDoc, data,objKey))
    
    }

/*     const loadProductsFn = () => {
        console.log("test add line", customerProducts)
        setLoadProducts(true)
        
       
    } */
    const POSITIONS = InsertProduct({data:{siteRegisters, register, existingProducts: [manualDoc], returnData: true}})
    const docs = POSITIONS?.data?.length > 0 ? POSITIONS?.data : [manualDoc]
    const docsWithDescription = () => docs?.map?.((doc)=>({...doc, descriptionText: doc?.description?.blocks?.map?.((x)=>x?.text)?.toString()})) 
    
    const testFunction = () => {
      console.log("TEST MANUAL", {
        docs: docsWithDescription(),
        siteRegisters: siteRegisters,
        manualDoc: manualDoc

      })
    }
    const saveManualProduct = () => {
      
      saveFn(docsWithDescription())
      //console.log("MANUAL DOC", docsWithDescription())
/*       setManualDoc({
        _id: uuidv4(),
        _key: keyId(),
        ...defaultManualDoc,
      }) */
    }
    
    
  return (
    <div className="products-heading">
      <VisDiv rules={[POSITIONS?.data?.length < 1]} style={{display:"flex", alignItems:"center"}}>
          <p style={{padding:"2px"}} >{`Unità: `}</p>
          <TextField 
              //onBlur={()=> setDoc({...unitDoc, unit: Number(unitDoc?.unit)})}
              value={newUnit} 
              onChange={(e) => {
                console.log("UNITA' NO POSITION")
                setNewUnit(e.target.value)
                //setManualDoc({...manualDoc, quantity: e.target.value, unit: e.target.value})

              }} 
              //label={"UNITA'"}
              type={"text"}
              //description={"Inserire il numero di unità. Per esempio se deve uscire più di una volta, come nel caso dei cartelli nelle porte/uscite a doppia anta o nel numero dei Kg per lo smaltimento degli estintori"} 
          />
      </VisDiv>
      {POSITIONS?.returnStatement}
      <button onClick={testFunction}>test manual prod</button>
        <VisDiv>
            <GroupedPin 
              manualAdd={true} 
              setProduct={setProduct}
              allProducts={{customerProducts, priceList}} 
              offer={offer} 
              item={manualDoc} 
              setItem={setContent} 
              index={0} 
              commonStyle={commonStyle} 
              edit={true}
            /> 
        </VisDiv>
      <div style={{display:"flex"}}>
        <VisDiv rules={[true]} type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={saveManualProduct}>
          <FiSave            
              size={15}
              color={"white"}
          />
      </VisDiv>
      <VisDiv rules={[true]} type='button' className='round-back-button' style={{color:"white",marginLeft:"10px",backgroundColor:"black"}} onClick={()=>setIsAdding(false)}>
          X
      </VisDiv>
      </div>

    </div>
  )
}

export default AddManualProduct

